import { render, staticRenderFns } from "./BusinessStep.vue?vue&type=template&id=4439aabc&scoped=true"
import script from "./BusinessStep.vue?vue&type=script&lang=js"
export * from "./BusinessStep.vue?vue&type=script&lang=js"
import style0 from "./BusinessStep.vue?vue&type=style&index=0&id=4439aabc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439aabc",
  null
  
)

export default component.exports